import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface ICurrentLocationIconProps extends IConDefaultType {}

function CurrentLocationIcon({ color, className, size = 40, rotate, flip }: ICurrentLocationIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 54 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="btn/Current_Location" filter="url(#filter0_d_5009_220469)">
          <path
            id="Vector"
            d="M27.3684 5H26.6316C17.4653 5 10 12.2393 10 21.1282C10 24.9212 11.3869 28.5986 13.9006 31.4986L24.6813 43.9493C25.2556 44.6112 26.1007 45 27 45C27.8993 45 28.7444 44.6217 29.3187 43.9493L40.0994 31.4986C42.6131 28.5986 44 24.9107 44 21.1282C44.0108 12.2393 36.5456 5 27.3684 5ZM27 31.2044C21.2575 31.2044 16.6093 26.6969 16.6093 21.1282C16.6093 15.5595 21.2683 11.052 27 11.052C32.7317 11.052 37.3907 15.5595 37.3907 21.1282C37.3907 26.6969 32.7425 31.2044 27 31.2044Z"
            fill="#00C3DD"
          />
          <circle id="Ellipse 19" cx="27" cy="21" r="11" fill="white" />
          <path
            id="icon_Profile"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5621 19C22.4247 19 23.1241 19.6994 23.1241 20.562C23.1241 21.4247 22.4247 22.124 21.5621 22.124C20.6994 22.124 20 21.4247 20 20.562C20 19.6994 20.6994 19 21.5621 19ZM32.4381 19C33.3007 19 34.0001 19.6994 34.0001 20.562C34.0001 21.4247 33.3007 22.124 32.4381 22.124C31.5754 22.124 30.876 21.4247 30.876 20.562C30.876 19.6994 31.5754 19 32.4381 19ZM29.0182 20.9634C29.0182 22.0858 28.108 22.9959 26.9856 22.9959C25.8632 22.9959 24.953 22.0858 24.953 20.9634H29.0182Z"
            fill="#00C3DD"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_5009_220469"
            x="-3"
            y="0"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.4 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5009_220469" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5009_220469" result="shape" />
          </filter>
        </defs>
      </svg>
    </i>
  );
}

export default CurrentLocationIcon;
